import { Component, Input, OnInit } from '@angular/core';
import { getAirLine } from '@utils/functions/general';
/**
 * Componente que muestra información de una aerolínea basada en su código de operador.
 * 
 * Obtiene la imagen, el texto y la URL asociada a la aerolínea utilizando la función `getAirLine`.
 */

/**
 * Interfaz para definir las propiedades de la aerolínea.
 */
interface OperatingCarrierProps {
  url?: string;
  img?: string;
  txt?: string;
}

@Component({
    selector: 'app-air-lines',
    templateUrl: './air-lines.component.html',
    styleUrls: ['./air-lines.component.scss'],
    standalone: false
})

export class AirLinesComponent implements OnInit {

   /** Código de la aerolínea operadora, por defecto "AM" */
   @Input() operatingCarrier: string = 'AM';

   /** Propiedades de la aerolínea obtenidas mediante `getAirLine` */
   operatingCarrierProps: OperatingCarrierProps;
  constructor() { }

  ngOnInit(): void {
   this.operatingCarrierProps =  getAirLine(this.operatingCarrier);
  }
 /**
   * Obtiene la imagen del operador de la aerolínea.
   */
  get imgOperatingCarrier() {
    return this.operatingCarrierProps.img;
  }
  /**
   * Obtiene el nombre del operador de la aerolínea.
   */
  get txtOperatingCarrier() {
    return this.operatingCarrierProps.txt;
  }
 /**
   * Obtiene la URL asociada a la aerolínea.
   */
  get urlOperatingCarrier() {
    return this.operatingCarrierProps.url;
  }

}
